export enum TypeTensionLink {
    Low220 = '0,22',
    Low380 = '0,38',
    Medium15 = '15',
    Medium20 = '20'
}



// WEBPACK FOOTER //
// ./src/app/models/request-and-responses/rest-api/enums/typeTensionLink.enum.ts